import { Fragment, useRef } from "react";
import css from "./App.module.scss";
import Header from "./components/header/Header";
import Card from "./components/card/Card";

function App() {

  const ref = useRef();

  return (
    <Fragment>
      <Header innerRef={ref} />
      <section className={css.lead} ref={ref}>
      <p>Ну что, женщины? Как настроение? Надеемся, совсем уже предпраздничное! Ну, в ожидании сюрпризов и подарков от своих ненаглядных...</p>
      <p>Именно для них, таких любимых и любящих, редакция «ВБ!» подготовила рейтинг подарков к этому замечательному весеннему празднику.</p>
      <p>Знакомьтесь, мужчины, решайте, выбирайте и вперёд, по магазинам!</p>
      <p>Времени осталось совсем немного, весна — она на пороге!</p>
      </section>
      <section className={css.container}>

      <h2 className={css.sectionHead}>Для самых утончённых и хозяйственных</h2>
        <Card
          title="Рейтинг подарков от магазина «Красотка»"
          label="Реклама. ИП Бурова Гульнара Ильфатовна. ИНН 660205149800. ERID 2Vtzqx3qfrq"
          images={[
            "./images/krasotka/1.jpg",
            "./images/krasotka/2.jpg",
            "./images/krasotka/3.jpg",
            "./images/krasotka/4.jpg",
            "./images/krasotka/5.jpg",
            "./images/krasotka/6.jpg",
            "./images/krasotka/7.jpg",
            "./images/krasotka/8.jpg",
            "./images/krasotka/9.jpg",
            "./images/krasotka/10.jpg"
          ]}
        >
          <p><strong>Купите и празднично оформите подарки прямо у нас! Огромный выбор упаковки! В том числе для цветов</strong></p>
          <ul>
          <li>Парфюмерия</li>
          <li>Косметика</li>
          <li>Подарочные наборы</li>
          <li>Товары для маленьких модниц</li>
          <li>Бижутерия</li>
          <li>Огромный выбор лаков для профессионального маникюра</li>
          <li>Всё для рукоделия и кулинарии</li>
          <li>Одноразовая посуда для будней и праздников</li>
          <li>Воздушные шары</li>
          <li>И многое другое</li>
          </ul>
          <p><strong>Спешите к нам! Ул. Ленина, 10</strong></p>
        </Card>

        <h2 className={css.sectionHead}>Для самых очаровательных и практичных</h2>
        <Card
          title="Рейтинг подарков от магазина «Радуга»:"
          label="Реклама. ИП Ольков Георгий Юрьевич. ИНН 660200017888. ERID 2Vtzqv4EzFT"
          images={[
            "./images/raduga/1.jpg",
            "./images/raduga/2.jpg",
            "./images/raduga/3.jpg",
            "./images/raduga/4.jpg",
            "./images/raduga/5.jpg",
            "./images/raduga/6.jpg",
            "./images/raduga/7.jpg",
            "./images/raduga/8.jpg",
            "./images/raduga/9.jpg",
            "./images/raduga/10.jpg"
          ]}
        >
          <ul>
          <li>Косметика</li>
          <li>Парфюмерия</li>
          <li>Сувениры</li>
          <li>Посуда</li>
          <li>Галантерея</li>
          <li>Постельное бельё</li>
          <li>Полотенца</li>
          <li>Бытовые мелочи</li>
          <li>Подарочные сертификаты</li>
          </ul>
          <p><strong>«Радуга» (ул. Молодежи, 4)</strong></p>
          <p><strong><a href="https://shopraduga.ru" target="_blank">shopraduga.ru</a></strong></p>
        </Card>

        <h2 className={css.sectionHead}>Для самых ярких и стильных</h2>
        <Card
          title="Рейтинг подарков от магазина женской одежды «Симпатия»"
          label="Реклама. ИП Карпенкова Наталья Викторовна. ИНН 660203016868. ERID 2VtzqxV8Vsf"
          images={[
            "./images/sim/1.jpg",
            "./images/sim/2.jpg",
            "./images/sim/3.jpg",
            "./images/sim/4.jpg",
            "./images/sim/5.jpg"
          ]}
        >
          <p>Мы используем весь наш опыт и знания, чтобы женщины в моделях из нашего магазина чувствовали себя уверенными, успешными и красивыми!</p>
          <p><strong>Приходите! Ул. Ленина, 10</strong></p>
        </Card>

        <h2 className={css.sectionHead}>Для самых обворожительных и увлечённых</h2>
        <Card
          title="Рейтинг подарков от магазина «Ариэль»"
          label="Реклама. ИП Востриков Игорь Анатольевич. ИНН 660200022207. ERID 2VtzqvFXyPP"
          images={[
            "./images/ariel/1.jpg",
            "./images/ariel/2.jpg",
            "./images/ariel/3.jpg",
            "./images/ariel/4.jpg",
            "./images/ariel/5.jpg",
            "./images/ariel/6.jpg",
            "./images/ariel/7.jpg",
            "./images/ariel/8.jpg"
          ]}
        >
          <ul>
          <li>Хороший выбор краски для волос: «Gamma», «Estel», «Stylist color pro», «Studio»</li>
          <li>Косметика</li>
          <li>Детская косметика (подарочные наборы для девочек, спреи, шампуни, украшения для волос)</li>
          <li>Бижутерия</li>
          <li>А также в продаже семена цветов и овощей</li>
          </ul>
          <p><strong>Ждём вас по адресу: ул. Свободы, 44</strong></p>
        </Card>

        <h2 className={css.sectionHead}>Для самых благоухающих и неподражаемых</h2>
        <Card
          title="Рейтинг подарков от ИП Сваловой О. С. (руководителя Бьюти Центра AVON):"
          label="Реклама. ИП Свалова Ольга Сергеевна. ИНН 660203856610. ERID 2VtzqvTTZwP"
          images={[
            "./images/avon/1.jpg",
            "./images/avon/2.jpg",
            "./images/avon/3.jpg",
            "./images/avon/4.jpg",
            "./images/avon/5.jpg",
            "./images/avon/6.jpg",
            "./images/avon/7.jpg",
            "./images/avon/8.jpg"
          ]}
        >
          <ul>
          <li>Парфюмерная вода «Today», «Attraction», «Far Away», «Perceive», «Little Black Dress», «Summer white», «Pur blanca», «Incandessence»</li>
          <li>Декоративная косметика</li>
          <li>Гели для душа</li>
          <li>Маски</li>
          <li>Уходовые средства для лица и тела</li>
          <li>Детская серия для маленьких принцесс</li>
          <li>Готовые подарочные наборы</li>
          <li>Профессиональная серия «Anew» для сохранения молодости и красоты кожи</li>
          <li>Подарочные сертификаты</li>
          </ul>
          <p><strong>Работаем для вас по адресу: пл. Советов, 1 (фойе магазина «Пятёрочка»)</strong></p>
        </Card>

        <h2 className={css.sectionHead}>Для самых таинственных и манящих</h2>
        <Card
          title="Рейтинг подарков от магазина «ЦарьСон»:"
          label="Реклама. ИП Кулишова Ольга Викторовна. ИНН 660200212871. ERID 2VtzqxFHPWy"
          images={[
            "./images/tsarson/1.jpg",
            "./images/tsarson/2.jpg",
            "./images/tsarson/3.jpg",
            "./images/tsarson/4.jpg",
            "./images/tsarson/5.jpg",
            "./images/tsarson/6.jpg",
            "./images/tsarson/7.jpg",
            "./images/tsarson/8.jpg",
            "./images/tsarson/9.jpg",
            "./images/tsarson/10.jpg"
          ]}
        >
          <ul>
          <li>Полотенца в подарочных наборах</li>
          <li>Домашний трикотаж (халаты, сорочки, пижамы, футболки, туники)</li>
          <li>Нижнее бельё</li>
          <li>Комплекты постельного белья</li>
          <li>Пледы</li>
          <li>Покрывала</li>
          <li>Одеяла</li>
          <li>Подушки</li>
          </ul>
          <p>Со 2 по 8 марта — скидка 10% на весь женский трикотаж!</p>
          <p><strong>Рады видеть вас по адресу: ул. Ленина, 12</strong></p>
          <p><strong><a href="https://vk.com/tsarson" target="_blank">vk.com/tsarson</a></strong></p>
        </Card>

        <h2 className={css.sectionHead}>Для самых романтичных и жизнерадостных</h2>
        <Card
          title="Рейтинг подарков от"
          label="Реклама. ИП Плотников Александр Сергеевич. ИНН 590411011190. ERID 2VtzqxXfcss"
          images={[
            "./images/9os/1.jpg",
            "./images/9os/2.jpg",
            "./images/9os/3.jpg",
            "./images/9os/4.jpg",
            "./images/9os/5.jpg"
          ]}
        >
          <img src="./images/9os/logo.jpg" style={{ maxWidth: "100%", marginBottom: 25 }}/>
          <h5>Натали Торт 1,050 г — Номинация — «Самый Женский»</h5> 
          <p>Сочетание макового, орехового и какао бисквитов с прослойкой сметанно-сливочного крема. Торт оформлен сливочным кремом</p>

          <h5>Дамский каприз Торт 1,300 г — Номинация — «Самый Цветочный»</h5>
          <p>Светлый бисквит, сливочный крем, мягкий грильяж из ореховой пасты, миндаля, арахиса и вафельной крошки</p>

          <h5>Сгущёнкерс Торт 0,700 г — Номинация — «Мужское наслаждение»</h5>
          <p>Сметанные бисквиты с какао, мягкий сливочный крем, начинка вареная сгущенка и арахис</p>
          <h5>Мишутка Торт 1,000 г — Номинация — «Детское счастье»</h5>
          <p>Бисквит сметанный с какао, сливочный крем с начинкой «Вареная сгущенка»</p>

          <h5>Фантазия Голд Торт 1,500 г — Номинация — «Самый фруктовый»</h5> 
          <p>Светлый бисквит, сливочно-сырный крем. Поверхность оформлена персиками и мандаринами</p>
          <p><strong>Приходите за вкусными тортами по адресу: ул. Ленина, 56</strong></p>
          <p><strong><a href="https://www.9ostrovov.ru" target="_blank">www.9ostrovov.ru</a></strong></p>
          <p><strong><a href="http://9ostrovov-excursion.ru" target="_blank">9ostrovov-excursion.ru</a></strong></p>
          <p><strong><a href="https://vk.com/9ostrovov" target="_blank">vk.com/9ostrovov</a></strong></p>
        </Card>

      </section>
    </Fragment>
  );
}

export default App;
